import { render } from "./MessageNotification.vue?vue&type=template&id=0e3b026e&scoped=true&ts=true"
import script from "./MessageNotification.vue?vue&type=script&lang=ts"
export * from "./MessageNotification.vue?vue&type=script&lang=ts"

import "./MessageNotification.vue?vue&type=style&index=0&id=0e3b026e&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_eu_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e3b026e"]])

export default __exports__